export const hasPage = (pages, pageAlias) => {
  return pages.some(page => page.alias === pageAlias)
}
